import VueRouter, { Route } from 'vue-router';
import {
    getWelcomeNotificationKey,
    getWelcomeNotificationOptions,
    getWelcomeNotificationParams,
    Jurisdiction,
} from '@gig/magic-jurisdictions';
import { notificationService } from '@gig/magic-messaging';
import { translate as $t } from '@gig/magic-common';

import { RouteName } from '../../../routes/routes.constants';
import { ILoginHistoryItem } from '@gig/magic-sdk/dist/adapter/users/getLoginHistory';
import { getUserJurisdiction } from '../helpers/jurisdiction.helpers';
import {
    ACCOUNT_REQUIRES_VERIFICATION_QUERY,
    USER_FIRST_LOGGED_IN_QUERY,
    USER_SET_FIRST_LOG_IN,
} from '@gig/magic-messages';

export function initAglcFirstLoginGuard(router: VueRouter) {
    router.beforeResolve(async (route: Route, _, next) => {
        const { params, fullPath } = route;

        if (!(await isAglc())) {
            return next();
        }

        if (!(await isFirstLogin())) {
            return next();
        }

        resetFirstLogin();

        const requiresVerification = await window.queryBus.query<boolean>(
            ACCOUNT_REQUIRES_VERIFICATION_QUERY,
        );

        if (requiresVerification) {
            next();
        } else {
            showFirstLoginWelcomeNotification();
            return next({
                name: RouteName.VIEW_LIMITS,
                params,
                query: {
                    backTo: fullPath,
                },
            });
        }
    });
}

async function isAglc(): Promise<boolean> {
    return (await getUserJurisdiction()) === Jurisdiction.AGLC;
}

function isFirstLogin() {
    return window.queryBus.query<boolean>(USER_FIRST_LOGGED_IN_QUERY);
}

function resetFirstLogin() {
    window.commandBus.publish(USER_SET_FIRST_LOG_IN, false);
}

async function showFirstLoginWelcomeNotification() {
    const { key, params, options } = await getFirstLoginWelcomeNotification();
    notificationService.show($t(key, params), {
        uniqueID: 'login-welcome-notification',
        ...options,
    });
}

async function getFirstLoginWelcomeNotification() {
    const userJurisdiction = await getUserJurisdiction();

    // NOTE: on first login, the login history is empty
    const loginHistory: ILoginHistoryItem[] = [];

    return {
        key: getWelcomeNotificationKey(userJurisdiction, loginHistory),
        params: getWelcomeNotificationParams(userJurisdiction, loginHistory),
        options: getWelcomeNotificationOptions(userJurisdiction, loginHistory),
    };
}
